import MusicServiceIcon from '../MusicServiceIcon';
import { MUSIC_SERVICE_LABELS } from '../../utils/exportUtils';
import '../../styles/auth.css';

const SERVICES = ['spotify', 'apple-music'];

/**
 * Side-by-side Spotify / Apple Music choice used in the signup forms.
 * Controls where song links open; changeable later in Settings.
 */
function MusicServicePicker({ value, onChange }) {
  return (
    <div className="auth-service-picker" role="radiogroup" aria-label="Music service">
      {SERVICES.map((service) => (
        <button
          key={service}
          type="button"
          role="radio"
          aria-checked={value === service}
          className={`auth-service-option ${value === service ? 'active' : ''}`}
          onClick={() => onChange(service)}
        >
          <MusicServiceIcon service={service} size={16} />
          <span>{MUSIC_SERVICE_LABELS[service]}</span>
        </button>
      ))}
    </div>
  );
}

export default MusicServicePicker;
